import type { ApiOptions } from './declare'

// axios 默认配置
export const axiosConfig = {
  timeout: 20000,
  maxContentLength: 2000,
}

// api 接口配置
export const apiConfig = {
  // 修正路径，可用这个控制接口版本号，比如 /apiv2
  prefixPath: '/api',
  // $api['common/getUserInfo'] 中的 common/getUserInfo 分隔符，分割命名空间和接口
  sep: '/',
}

// api 拦截配置
export const apiOptions: ApiOptions = {
  dataField: 'Data', // 响应成功时，取数据字段
  successField: 'IsSuccessful', // 接口是否响应成功字段
  errorMsgField: 'ErrorMessage', // 接口响应失败时，取报错信息字段
}